import EmailVerificationContainer from "../components/pageComponents/Login/EmailVerificationContainer";

const EmailVerification=()=>{
    return(
    <div><EmailVerificationContainer /></div>);
}
export default EmailVerification;